import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';

const CURRENT_YEAR = new Date().getFullYear();
const DAYS = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));
const MONTHS = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
const YEARS = Array.from({ length: 11 }, (_, i) => String(CURRENT_YEAR - 5 + i));

const parse = (value) => {
    if (!value) return { day: '', month: '', year: '' };
    const parts = value.split('-');
    if (parts.length !== 3) return { day: '', month: '', year: '' };
    return { day: parts[0], month: parts[1], year: parts[2] };
};

const TemplateDateInput = ({ label, value, onChange, disabled }) => {
    const [parts, setParts] = useState(() => parse(value));

    // Sync from parent only when the parent value changes externally
    // (e.g. modal reset), but not in response to our own onChange calls.
    useEffect(() => {
        setParts(parse(value));
    }, [value]);

    const update = (part, partValue) => {
        const next = { ...parts, [part]: partValue };
        setParts(next);
        if (next.day && next.month && next.year) {
            onChange(`${next.day}-${next.month}-${next.year}`);
        } else {
            onChange(null);
        }
    };

    const { day, month, year } = parts;

    return (
        <div className="space-y-1">
            {label && (
                <label className="label-base flex items-center gap-1.5">
                    <Calendar className="w-4 h-4" />
                    {label}
                </label>
            )}
            <div className="flex items-center gap-1.5">
                <select
                    value={day}
                    onChange={(e) => update('day', e.target.value)}
                    disabled={disabled}
                    className="input-base flex-1 min-w-0"
                    aria-label="Day"
                >
                    <option value="">Day</option>
                    {DAYS.map((d) => (
                        <option key={d} value={d}>{d}</option>
                    ))}
                    <option value="[CurrentDay]">[CurrentDay]</option>
                </select>

                <span className="text-text-muted text-sm flex-shrink-0">–</span>

                <select
                    value={month}
                    onChange={(e) => update('month', e.target.value)}
                    disabled={disabled}
                    className="input-base flex-1 min-w-0"
                    aria-label="Month"
                >
                    <option value="">Month</option>
                    {MONTHS.map((m) => (
                        <option key={m} value={m}>{m}</option>
                    ))}
                    <option value="[CurrentMonth]">[CurrentMonth]</option>
                </select>

                <span className="text-text-muted text-sm flex-shrink-0">–</span>

                <select
                    value={year}
                    onChange={(e) => update('year', e.target.value)}
                    disabled={disabled}
                    className="input-base flex-1 min-w-0"
                    aria-label="Year"
                >
                    <option value="">Year</option>
                    {YEARS.map((y) => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                    <option value="[CurrentYear]">[CurrentYear]</option>
                </select>
            </div>
        </div>
    );
};

export default TemplateDateInput;
